import { useContext } from 'react';

import AlertContext from './alert.context';

function useAlert() {
  const context = useContext(AlertContext);

  if (!context) {
    throw new Error('useAlert must be used within AlertContext');
  }

  return context;
}

export default useAlert;